import { LogoMark } from "./Logo";

/** Logo mark + lettering. `compact` shows "COP"; otherwise "Consultorio Odontológico Pilar" with bold C, O, P. */
export function Wordmark({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={className} style={{ display: "inline-flex", alignItems: "center", gap: "0.6em" }}>
      <LogoMark className="wordmark-mark" />
      {compact ? (
        <span className="wordmark-text wordmark-compact" aria-label="Consultorio Odontológico Pilar">
          <span aria-hidden>COP</span>
        </span>
      ) : (
        <span className="wordmark-text" aria-label="Consultorio Odontológico Pilar">
          <span aria-hidden>
            <b>C</b>onsultorio <b>O</b>dontológico <b>P</b>ilar
          </span>
        </span>
      )}
    </span>
  );
}
